import React from "react";

export default function MessageReveal({ message, revealed }) {

  let letterIndex = 0;

  return (
    <div className="message">

      {message.split("").map((char, i) => { // Iterate through each character in the message

        const isLetter = /[а-яА-Яa-zA-Z0-9]/.test(char); // Regex to check if the character is a letter or number

        if (!isLetter) { // If it's not a letter (e.g., space or punctuation) - show it immediately without waiting for reveal
          return (
            <span key={i} className="symbol">
              {char}
            </span>
          );
        }

        const show = letterIndex < revealed; // Determine if the current letter should be revealed based on the revealed count
        letterIndex++;

        return ( // For the letters - show the character if it's revealed, otherwise show an underscore. Apply a reveal animation class when the letter is revealed.
          <span key={i} className={`letter ${show ? "letter-reveal" : ""}`}>
            {show ? char : "_"}
          </span>
        );

      })}

    </div>
  );

}